<div style="position: relative; min-height: 630px" >
  <div id="load" [hidden]="renderizou"  ></div>
  <div id="cardPaymentBrick_container" ></div>
</div>
